export default "__VITE_ASSET__ab724060__"